export default "__VITE_ASSET__212960b7__"